import React from 'react'

import clsx from 'clsx'
import { Check } from 'lucide-react'

interface CheckboxProps {
  checked: boolean
  hint?: string
  id: string
  label: string
  onChange: (next: boolean) => void
}

export const Checkbox: React.FC<CheckboxProps> = ({ checked, hint, id, label, onChange }) => {
  return (
    <label className="user-profile-check-row" htmlFor={id}>
      <span className={clsx('user-profile-check-box', checked && 'user-profile-check-box_on')}>
        <input
          checked={checked}
          className="user-profile-check-box__input"
          id={id}
          type="checkbox"
          onChange={(event) => onChange(event.target.checked)}
        />
        {checked ? <Check aria-hidden size={16} strokeWidth={2.5} /> : null}
      </span>
      <span className="user-profile-check-row__copy">
        <span className="user-profile-check-row__label">{label}</span>
        {hint ? <span className="user-profile-check-row__hint">{hint}</span> : null}
      </span>
    </label>
  )
}
